module.exports = __webpack_public_path__ + "img/39befb6.jpg";